<template>
  <el-dialog @close="closeDialog" :append-to-body="false" :visible.sync="dialogVisible" width="900px" top="10%">
    <el-form class="flex-item role-form" ref="validateForm" :model="form" :rules="rules" :validate-on-rule-change="false" label-width="100px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="登录账号:" prop="loginName">
            <el-input v-model="form.loginName"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="联系邮箱:" prop="email">
            <el-input v-model="form.email"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="手机号:" prop="phone">
            <el-input v-model="form.phone"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="验证码:" prop="captcha">
            <el-input v-model="form.captcha" style="width: 60%; vertical-align: top;"></el-input>
            <div @click="getCaptcha" style="display: inline-block; width: 40%;">
              <el-image :src="captchaImg" alt="验证码" style="width: 110px; height: 38px;"></el-image>
            </div>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="flex-item" style="text-align: center; margin-top: 20px">
        <el-button type="primary" @click="forgetPassword">确 定</el-button>
      </div>
    </el-form>
  </el-dialog>
</template>

<script>
import {forgetPassword, getCaptchaImg} from "@/api/api";
import {checkPhone, checkEmail} from "@/assets/js/validator";

export default {
  data() {
    return {
      form: {
        loginNane: '',
        phone: '',
        email: '',
        captchaKey: '',
        captcha: ''
      },
      isBtnLoading: false,
      dialogVisible: false,
      captchaImg: "",
      rules: {
        loginName: [
          {message: "登录账号不能为空", trigger: "blur", required: true},
        ],
        phone: [{validator: checkPhone, required: true, trigger: "blur"}],
        email: [{validator: checkEmail, required: true, trigger: "blur"}],
        captcha: [{message: "请输入验证码", trigger: "blur", required: true}]
      },
    };
  },
  mounted() {
    // this.getCaptcha();
  },
  methods: {
    getCaptcha() {
      getCaptchaImg().then(res => {
        console.log(res.captchaKey)
        this.form.captchaKey = res.captchaKey;
        this.captchaImg = res.captchaImage;
      })
    },
    open() {
      this.dialogVisible = true
      this.form = {
        loginNane: '',
        phone: '',
        email: '',
        captchaKey: '',
        captcha: ''
      };
      // 弹窗打开时再获取验证码
      this.getCaptcha();
    },
    closeDialog() {
      this.dialogVisible = false;
      this.$refs.validateForm.clearValidate()
    },
    forgetPassword() {
      this.$refs["validateForm"].validate((valid) => {
        if (valid) {
          forgetPassword({...this.form}).then((res) => {
            if (res.code === '200') {
              this.dialogVisible = false;
              this.$message({
                type: "success",
                message: "您的密码已发送至您的邮箱，请注意查收。",
              });
            } else {
              this.$message.error(res.message);
            }
          });
        }
      });
    },
  },
};
</script>

